module.exports = __webpack_public_path__ + "img/block6-card6.1134d2ca.svg";